
const digest = '836bf136c1013e159ea516637b3800f5959d03207f11af4f0917a1f0b68c4a8f';
const classes = {"wrapper":"_wrapper_1r8oe_1","item":"_item_1r8oe_7","accessDenied":"_accessDenied_1r8oe_25","content":"_content_1r8oe_36","title":"_title_1r8oe_40","subtitle":"_subtitle_1r8oe_44","textWarning":"_textWarning_1r8oe_51","text2":"_text2_1r8oe_57"};
const css = `._wrapper_1r8oe_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_1r8oe_1 ._item_1r8oe_7 {
  background: #ffffff;
  border-radius: 15px;
  padding: 14px 20px;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 76px;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_1r8oe_1 ._item_1r8oe_7:hover {
  transform: scale(1.02);
}
._wrapper_1r8oe_1 ._item_1r8oe_7._accessDenied_1r8oe_25 {
  background: #eaeaea;
  cursor: not-allowed;
  opacity: 0.6;
}
._wrapper_1r8oe_1 ._item_1r8oe_7._accessDenied_1r8oe_25:hover {
  transform: none;
}
._wrapper_1r8oe_1 ._item_1r8oe_7._accessDenied_1r8oe_25 img {
  opacity: 0.6;
}
._wrapper_1r8oe_1 ._item_1r8oe_7 ._content_1r8oe_36 {
  display: flex;
  flex-direction: column;
}
._wrapper_1r8oe_1 ._item_1r8oe_7 ._content_1r8oe_36 ._title_1r8oe_40 {
  font-size: 18px;
  font-weight: 500;
}
._wrapper_1r8oe_1 ._item_1r8oe_7 ._content_1r8oe_36 ._subtitle_1r8oe_44 {
  font-size: 14px;
  color: #747474;
}
._wrapper_1r8oe_1 ._item_1r8oe_7 img {
  height: 25px;
}
._wrapper_1r8oe_1 ._textWarning_1r8oe_51 {
  font-size: 16px;
  font-weight: 500;
  color: #d81616;
  margin: 10px 0;
}
._wrapper_1r8oe_1 ._text2_1r8oe_57 {
  margin-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  